import { Flex, type FlexProps } from '@frontend/legacy-components';

export const ViewerToolsBar = ({ children, ...props }: FlexProps) => {
  return (
    <Flex
      align="center"
      gap="0.25rem"
      p="0.25rem"
      justify="center"
      minW={0}
      wrap="wrap"
      bg="page.surface"
      /* Takes pointer events back from the pass-through band around it. */
      pointerEvents="auto"
      border="1px solid"
      borderColor="separator.border"
      borderRadius="0.5rem"
      boxShadow="popover"
      className="viewer-tools-bar"
      {...props}
    >
      {children}
    </Flex>
  );
};

ViewerToolsBar.displayName = 'ViewerToolsBar';
